module.exports = __webpack_public_path__ + "img/credit-card-edit.a5d97e91.svg";